export default __webpack_public_path__ + "static/media/aboutimage.1e5f3b69.jpg";